import { render, staticRenderFns } from "./SlideNumbers.vue?vue&type=template&id=a2d6fa16"
import script from "./SlideNumbers.vue?vue&type=script&lang=js"
export * from "./SlideNumbers.vue?vue&type=script&lang=js"
import style0 from "./SlideNumbers.vue?vue&type=style&index=0&id=a2d6fa16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports